module.exports = __webpack_public_path__ + "img/nodeType6.0498a891.svg";